export default defineNuxtRouteMiddleware((to) => {
  if (to.path === '/routes-2') {
    return navigateTo('/id/layanan/rute/sumatra', { redirectCode: 301 })
  }
})
